import { createIcon } from '@chakra-ui/react';

export const InfoBoldIcon = createIcon({
  displayName: 'InfoBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="14"
        // height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 7C0.5 3.41 3.41 0.5 7 0.5C10.59 0.5 13.5 3.41 13.5 7C13.5 10.59 10.59 13.5 7 13.5C3.41 13.5 0.5 10.59 0.5 7ZM6.304 6.03867C7.068 5.65667 7.92867 6.34733 7.72133 7.176L7.24867 9.06667L7.27667 9.05333C7.39414 9.00169 7.52698 8.99719 7.64768 9.04077C7.76839 9.08435 7.86771 9.17267 7.9251 9.28745C7.98249 9.40223 7.99355 9.53468 7.956 9.65739C7.91844 9.7801 7.83514 9.88367 7.72333 9.94667L7.69667 9.96133C6.932 10.3433 6.07133 9.65267 6.27867 8.824L6.752 6.93333L6.724 6.94667C6.66503 6.97944 6.60003 6.99994 6.53292 7.00693C6.46581 7.01393 6.39798 7.00726 6.33352 6.98734C6.26905 6.96743 6.20929 6.93467 6.15782 6.89105C6.10635 6.84742 6.06424 6.79383 6.03403 6.7335C6.00382 6.67317 5.98613 6.60735 5.98204 6.54C5.97794 6.47266 5.98751 6.40518 6.01018 6.34163C6.03285 6.27808 6.06815 6.21978 6.11394 6.17023C6.15974 6.12069 6.21509 6.08092 6.27667 6.05333L6.304 6.03867ZM7 5C7.13261 5 7.25979 4.94732 7.35355 4.85355C7.44732 4.75979 7.5 4.63261 7.5 4.5C7.5 4.36739 7.44732 4.24021 7.35355 4.14645C7.25979 4.05268 7.13261 4 7 4C6.86739 4 6.74022 4.05268 6.64645 4.14645C6.55268 4.24021 6.5 4.36739 6.5 4.5C6.5 4.63261 6.55268 4.75979 6.64645 4.85355C6.74022 4.94732 6.86739 5 7 5Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
